let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bZUwr")).then(() => parcelRequire('cM49F'));